<!-- Aufbau nach dem Muster von rent-module/containers/tasks/tasks.component.html:
     pageTitle-box, p-tabView mit Count-Badge, Zeilen, Leerzustand, Fussbereich. Statt des
     Paginators steht unten "Mehr laden" — der Stream hat weder Offset noch totalCount
     (#736 Entscheidung 11). -->
<div>

  <nx-pageTitle-box
    [label]="'notificationCenterComponent.headline' | translate"
    [icon]="'icon-notification'"
    [iconToolTip]="'notificationCenterComponent.headline' | translate">
    <ng-template nxTemplate="end">
      <nx-default-button
        *ngIf="unreadCount() > 0"
        [style]="'light'"
        (click)="markAllAsRead()"
        [label]="'notificationCenterComponent.markAllAsRead'"
        class="mr-2">
      </nx-default-button>
      <!-- Gleiche Farbgebung wie der Knopf daneben — auf der Seite ist das 'light'. -->
      <nx-default-button
        [style]="'light'"
        [icon]="'icon-settings'"
        [tooltip]="'notificationCenterComponent.settings' | translate"
        (click)="goToSettings()">
      </nx-default-button>
    </ng-template>
  </nx-pageTitle-box>

  <div class="flex flex-row">
    <div class="w-full">
      <p-tabView [activeIndex]="activeTabIndex()" (activeIndexChange)="onTabChange($event)">
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>{{ 'notificationCenterComponent.tabs.unread' | translate }}</span>
            <!-- Abweichung vom /tasks-Muster: dort haengt das Badge am AKTIVEN Tab und zeigt
                 totalElements. Eine Gesamtzahl gibt es hier nicht, deshalb sitzt es fest am
                 Ungelesen-Tab und zeigt den Zaehler — die einzige Zahl, die exakt bekannt ist. -->
            <nx-count-badge *ngIf="unreadCount() > 0" [count]="unreadCount()" />
          </ng-template>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>{{ 'notificationCenterComponent.tabs.all' | translate }}</span>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>

  <!-- Kein border-t auf den folgenden Bloecken: .p-tabview-nav bringt bereits eine untere Linie mit
       (ng-theme.scss:12-15), ein zusaetzlicher oberer Rahmen ergaebe eine Doppellinie. Auf /tasks
       ist das border-t richtig, weil dort die Filterleiste dazwischen sitzt — hier nicht. -->
  <!-- Pruefreihenfolge wie im Popover: error() VOR loading(). -->
  <div *ngIf="list.error()" class="bg-white px-5 py-4 text-[#c0123c]">
    {{ 'notificationCenterComponent.loadErrorMessage' | translate }}
  </div>
  <div *ngIf="!list.error() && list.loading()" class="bg-white flex flex-row justify-center py-8">
    <p-progressSpinner [style]="{width: '2rem', height: '2rem'}" strokeWidth="4"></p-progressSpinner>
  </div>

  <ng-container *ngIf="!list.error() && !list.loading()">
    <div class="bg-white">
      <ng-container *ngFor="let notification of list.items()">
        <!-- Kein Breitenmodus mehr: seit der Nacharbeit vom 19.08.2026 gibt es genau EIN
             Zeilenlayout. Diese Seite ist seither nicht mehr aus der Glocke verlinkt. -->
        <app-notification
          class="block border-b border-gray last:border-none"
          [notification]="notification"
          [list]="list">
        </app-notification>
      </ng-container>
    </div>
    <nx-empty-box
      *ngIf="list.items().length === 0"
      [label]="emptyStateKey()">
    </nx-empty-box>
    <div *ngIf="list.hasMore()" class="bg-white border-t px-3 py-2">
      <nx-default-button
        [style]="'light'"
        [width]="'full'"
        [disabled]="list.loadingMore()"
        (click)="list.loadMore()"
        [label]="list.loadingMore() ? 'notificationCenterComponent.loadingMore' : 'notificationCenterComponent.loadMore'">
      </nx-default-button>
    </div>
  </ng-container>

</div>
